import React, { useRef } from 'react'
import {
  Button, Row, Col,
} from 'antd'
import {
  LeftOutlined, RightOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
import { useIsSmallDevice } from '../../hookreducer/hooks'

import track from '../../engine/tracking'

import __ from '../../languages/parser'

import RecapMenu from './RecapMenu'

import {
  GF_URL, MF_URL, PF_URL, GS_URL, MS_URL,
} from '../../static/url'

const SIZE = 'default'

const ImageInsideButtonSmall = ({ src, alt, text }) => (
  <Row style={{ width: '100%' }}>
    <Col span={4} offset={1} style={{ textAlign: 'center' }}>
      <img src={src} style={{ height: '20px' }} alt={alt} />
    </Col>
    <Col span={19} style={{ textAlign: 'center' }}>
      {text}
    </Col>
  </Row>
)

const ImageInsideButton = ({ src, alt, text }) => (
  <Row style={{ width: '100%' }}>
    <Col span={6} style={{ textAlign: 'center' }}>
      <img src={src} style={{ height: '24px' }} alt={alt} />
    </Col>
    <Col span={18} style={{ textAlign: 'left' }}>
      {text}
    </Col>
  </Row>
)

const WallBaseMenuSmall = ({
  addElement,
}) => {
  const ref = useRef(null)
  const { left } = useScroll(ref)
  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'
  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  const MARGIN_BUTTON = '6px'

  const wallBaseStyle = {
    marginBottom: '0.4em',
    padding: 0,
  }

  const blocStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    maxHeight: '84px',
    borderRadius: '12px',
    fontSize: '0.8em',
  }

  const blocStyleButtons = {
    marginTop: '4px',
    display: 'flex',
    flexDirection: 'row',
  }

  return (
    <Row>
      <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'left' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('left')}
            >
              <LeftOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}

      </Col>
      <Col offset={1} span={20}>
        <div
          style={{
            overflowX: 'scroll',
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: '10px',
            height: '74px',
          }}
          ref={ref}
        >
          <div style={{ ...blocStyle, minWidth: '120%' }}>
            <div>
              {__('Height 77cm')}

            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...wallBaseStyle, marginRight: MARGIN_BUTTON }} block onClick={() => addElement('gridGF')}>
                <ImageInsideButtonSmall src={GF_URL} alt={__('GF')} text={__('GF_small')} />
              </Button>
              <Button size={SIZE} style={{ ...wallBaseStyle, marginRight: MARGIN_BUTTON }} block onClick={() => addElement('gridMF')}>
                <ImageInsideButtonSmall src={MF_URL} alt={__('MF')} text={__('MF_small')} />
              </Button>
              <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridPF')}>
                <ImageInsideButtonSmall src={PF_URL} alt={__('MF')} text={__('PF_small')} />
              </Button>
            </div>
          </div>

          <div style={{ ...blocStyle, minWidth: '80%' }}>
            <div>
              {__('Height 44cm')}
            </div>
            <div style={blocStyleButtons}>
              <Button size={SIZE} style={{ ...wallBaseStyle, marginRight: MARGIN_BUTTON }} block onClick={() => addElement('gridGS')}>
                <ImageInsideButtonSmall src={GS_URL} alt={__('GS')} text={__('GS_small')} />
              </Button>
              <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridMS')}>
                <ImageInsideButtonSmall src={MS_URL} alt={__('MS')} text={__('MS_small')} />
              </Button>
            </div>
          </div>
        </div>
      </Col>
      <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
        {scrollLimit === 'right' ? null
          : (
            <Button
              block
              type="text"
              size="small"
              style={{
                padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
              }}
              onClick={() => setScroll('right')}
            >
              <RightOutlined style={{ position: 'relative', top: '26px' }} />
            </Button>
          )}
      </Col>
    </Row>
  )
}

const WallBaseMenu = ({
  addElement, setTag, isTagged, setQuotes, isQuotes,
  metalColor, woodColor, setMetalColor, setWoodColor,
  setShowCalculatorModal, setShowBoxModal,
}) => {
  const wallBaseStyle = {
    marginBottom: '0.4em',
    padding: 0,
  }
  return (
    <>
      <Row>
        <span className="maker-subtitle">{`${__('Wall bases')} ${__('Height 77cm')}`}</span>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridGF')}>
          <ImageInsideButton src={GF_URL} alt={__('GF')} text={__('GF')} />
        </Button>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridMF')}>
          <ImageInsideButton src={MF_URL} alt={__('MF')} text={__('MF')} />
        </Button>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridPF')}>
          <ImageInsideButton src={PF_URL} alt={__('PF')} text={__('PF')} />
        </Button>
      </Row>

      <Row>
        <span className="maker-subtitle">{`${__('Wall bases')} ${__('Height 44cm')}`}</span>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridGS')}>
          <ImageInsideButton src={GS_URL} alt={__('GS')} text={__('GS')} />
        </Button>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => addElement('gridMS')}>
          <ImageInsideButton src={MS_URL} alt={__('MS')} text={__('MS')} />
        </Button>
      </Row>

      <Row style={{ marginTop: '2em' }}>
        <span className="maker-subtitle">{__('Advices')}</span>

        <Button
          size={SIZE}
          style={wallBaseStyle}
          block
          onClick={() => { track('showCalculator'); setShowCalculatorModal(true) }}
        >
          {__('Calculate')}
        </Button>

        <Button size={SIZE} style={wallBaseStyle} block onClick={() => { track('spaceDimensions'); setShowBoxModal(true) }}>
          {__('Space dimensions')}
        </Button>

      </Row>
      <Row>
        <RecapMenu
          setTag={setTag}
          isTagged={isTagged}
          setQuotes={setQuotes}
          isQuotes={isQuotes}
          metalColor={metalColor}
          woodColor={woodColor}
          setWoodColor={setWoodColor}
          setMetalColor={setMetalColor}
        />
      </Row>
    </>
  )
}

const WallBaseMenuContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <WallBaseMenuSmall {...props} /> : <WallBaseMenu {...props} />
}

export default WallBaseMenuContainer
